<template>
  <div class="dea-list-catalog bookmarks__sidebar bookmarks__sidebar--events">
    <SidebarLinkList :items="bookmarkTypes"> </SidebarLinkList>
  </div>
</template>

<script>
import SidebarLinkList from "@/components/elements/SidebarLinkList";

export default {
  name: "SidebarBookmarksEvents",
  components: { SidebarLinkList },

  props: {
    bookmarkTypes: {
      type: Array,
      required: true,
    },
  },
};
</script>
